const initialIncomes = [
  {
    id: 1,
    title: "Salary for October 2021",
    amount: 4256.95,
    category: "Inc/ Salary"
  },
  {
    id: 2,
    title: "Selling clothes on Vinted",
    amount: 170,
    category: "Inc/ Selling"
  }
];

export default initialIncomes;
